import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App'
import './styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { OpenFeature } from '@openfeature/web-sdk'
import './i18n'

Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN || undefined })
OpenFeature.setContext({ env: import.meta.env.MODE })
const queryClient = new QueryClient()
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '728050663550-beail8c1g0f8sd3ld6iovre7vtl2te1m.apps.googleusercontent.com'

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={googleClientId}>
          <App />
        </GoogleOAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
